"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _log = require("@/utils/log");
var _training = require("@/api/training");
var _lodash = _interopRequireDefault(require("lodash"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import moment from 'moment'
// import { writeGaEvent } from '@/utils/ga'
// import { parseTime } from '@/utils'
var _default = exports.default = {
  name: 'ILTAttendanceReport',
  data() {
    return {
      tableLoading: true,
      participantList: [],
      trainingId: '',
      trainingTitle: '',
      trainingSessions: [],
      teams: [],
      userTrainings: [],
      autoWidth: true,
      bookType: 'xlsx',
      exportDisable: true
    };
  },
  async created() {
    const tid = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
    const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
    await this.getTraining(token, tid);
    await this.getParticipantAndUserTraining(token, tid);
    await this.buildReport(this.trainingSessions, this.teams, this.userTrainings);
    this.tableLoading = false;
    this.exportDisable = false;
  },
  methods: {
    checkPermission: _permission.default,
    exportExcel() {
      const tid = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        const tHeader = ['ILT/VILT Session ID', 'Session Title', 'Event Timezone', 'Event Start Time (Local)', 'Event Start Time (UTC)', 'User Name', 'Email', 'Company', 'Job Title', 'Checkin Time (Local)', 'Checkin Time (UTC)'];

        // const data = this.formatJson(filterVal, list)
        const xdata = this.buildExcelData();
        excel.export_json_to_excel({
          header: tHeader,
          data: xdata,
          filename: 'ILT Attendance-' + tid,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        });
      });
    },
    async getTrainingParticipant() {
      const tid = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _training.getTrainingTeams)(token, tid).then(async response => {
        this.trainingId = tid;
        // this.participantList = response.data.rows[0].members
        var members = response.data.rows[0].members;
        await this.getAttendance(token, tid, members);
        this.tableLoading = false;
        this.exportDisable = false;
      }).catch(error => {
        (0, _log.showDebugLog)('ILT-AttendanceReport-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response })
      });
    },
    async getAttendance(token, tid, members) {
      for (let i = 0; i < members.length; i++) {
        await (0, _training.getUserTraining)(token, members[i].uuid).then(response => {
          // only return last 100 user training
          var userTrainings = response.data.rows;
          var userTraining = _lodash.default.find(userTrainings, t => {
            return t.training === tid;
          });

          // console.log('userTraining', userTraining)
          members[i].trainingTitle = userTraining && userTraining.trainingTitle ? userTraining.trainingTitle : '-';
          members[i].isCheckin = userTraining ? userTraining.onSiteCheckedIn : '-';
          members[i].checkinTime = userTraining && userTraining.onSiteCheckedInDateTime ? userTraining.onSiteCheckedInDateTime : '-';
        });
      }
      this.participantList = members;
    },
    async getTraining(token, tid) {
      await (0, _training.getTrainingById)(token, tid).then(response => {
        this.trainingId = tid;
        this.trainingTitle = response.data.title;
        this.trainingSessions = response.data.sessions;
        // console.log('getTraining', response.data.sessions)
      }).catch(error => {
        this.trainingId = tid;
        this.trainingTitle = '';
        this.trainingSessions = [];
        (0, _log.showDebugLog)('ILT-error', error);
      });
    },
    async getParticipantAndUserTraining(token, tid) {
      await (0, _training.getTeamAndUserTraining)(token, tid).then(response => {
        this.teams = response.data.teams[0].members;
        this.userTrainings = response.data.userTrainings;
        // console.log('team and userTraining', response.data)
      }).catch(error => {
        this.teams = [];
        this.userTrainings = [];
        (0, _log.showDebugLog)('ILT-Team-error', error);
      });
    },
    async buildReport(trainingSessions, teams, userTrainings) {
      for (var i = 0; i < trainingSessions.length; i++) {
        if (trainingSessions[i].allowCheckin) {
          for (var j = 0; j < teams.length; j++) {
            var checkInTimeUtc = this.getCheckInTime(teams[j].uuid, trainingSessions[i].id, userTrainings);
            var checkInTimeLocal = checkInTimeUtc ? (0, _momentTimezone.default)(checkInTimeUtc).tz(trainingSessions[i].start.timezone).format('YYYY-MM-DD HH:mm:ss') : '';
            var record = {
              sessionId: trainingSessions[i].id,
              sessionTitle: trainingSessions[i].title,
              eventStartTime: trainingSessions[i].start.utc,
              eventTimezone: trainingSessions[i].start.timezone,
              eventLocalStartTime: (0, _momentTimezone.default)(trainingSessions[i].start.utc).tz(trainingSessions[i].start.timezone).format('YYYY-MM-DD HH:mm:ss'),
              email: teams[j].email,
              name: `${teams[j].givenName} ${teams[j].familyName}`,
              jobTitle: teams[j].jobTitle,
              company: teams[j].orgName,
              checkinTimeLocal: checkInTimeLocal,
              checkinTime: checkInTimeUtc
            };
            this.participantList.push(record);
          }
        }
      }
    },
    getCheckInTime(uuid, sessionId, userTrainings) {
      var session;
      var checkinTime = '';
      var ut = _lodash.default.find(userTrainings, function (o) {
        return o.user === uuid;
      });
      if (ut) {
        session = _lodash.default.find(ut.sessions, function (s) {
          return s.sessionId === sessionId;
        });
        if (session) {
          checkinTime = session.checkedInDateTime ? session.checkedInDateTime : '';
        }
      }
      return checkinTime;
    },
    buildExcelData() {
      var excelData = [];
      for (var i = 0; i < this.participantList.length; i++) {
        excelData.push([_lodash.default.get(this.participantList[i], 'sessionId', ''), _lodash.default.get(this.participantList[i], 'sessionTitle', '').toString(), _lodash.default.get(this.participantList[i], 'eventTimezone', '').toString(), _lodash.default.get(this.participantList[i], 'eventLocalStartTime', '').toString(), _lodash.default.get(this.participantList[i], 'eventStartTime', '').toString(), _lodash.default.get(this.participantList[i], 'name', ''), _lodash.default.get(this.participantList[i], 'email', ''), _lodash.default.get(this.participantList[i], 'company', ''), _lodash.default.get(this.participantList[i], 'jobTitle', ''), _lodash.default.get(this.participantList[i], 'checkinTimeLocal', '').toString(), _lodash.default.get(this.participantList[i], 'checkinTime', '').toString()]);
      }
      return excelData;
    }
  }
};